module.exports = __webpack_public_path__ + "static/media/pp-providersTablet.e5070e3b.png";